<template>
  <div class="health_ambient">
    <van-nav-bar title="畜舍环境指标" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="畜舍环境指标" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap"> 
        <van-row>
            <van-collapse v-model="activeNames">
                <van-collapse-item title="1、猪圈舍和建筑" name="1">
                    <van-row>
                        <van-col span="24">
                           1）板条结构的地板设计应能承载相应阶段体重的猪。保证猪蹄无普遍损伤，板条的尺寸应符合以下要求：板条间隙的最大宽度，哺乳仔猪为11mm，断奶仔猪为14mm，育肥猪为18mm，母猪为20mm；板条最小宽度，哺乳仔猪和断奶仔猪50mm，育肥猪和母猪为80mm。
                        </van-col>
                        <van-col span="24">
                           2）为防止咬尾或其他恶习，应考虑周围环境和饲养密度，应能都为猪提供充足的环境空间和适于拱咬的物料，如适宜的链子、塑料物件等，但不能是轮胎或石槽里的食物。
                        </van-col>
                        <van-col span="24">
                           3）每头猪应能获得清洁干燥的躺卧区域。
                        </van-col>
                        <van-col span="24">
                           4）当使用垫草时，应加满或定期更换，以保持清洁卫生。
                        </van-col>
                        <van-col span="24">
                           5）舍内养猪应是封闭的，进出的门应受控制。
                        </van-col>
                        <van-col span="24">
                           6）体重大于30kg的生长育肥猪圈舍应配备喷淋系统，使其在炎热的气候条件下保持凉爽。此系统应避免热应激和导致躺卧区形成污垢。
                        </van-col>
                        <van-col span="24">
                           7）应设计通风系统，并通过该系统的维护和运作以防止空气中的污染物GB/T18407.3的要求，且一氧化碳浓度不得超过30×<span>  10 <sup class="up_hea">-6</sup></span>。判定标准是吸入的空气不应使人明显不舒服。
                        </van-col>
                    </van-row>
                   
                </van-collapse-item>
                <van-collapse-item title="2、猪舍内空气温度和相对湿度" name="2">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                
                                    <th colspan="1" rowspan="2">猪舍类别 </th>
                                    <th colspan="3">空气温度/℃</th>
                                    <th colspan="3">相对湿度/%</th>
                                </tr>
                                <tr>
                                    <td colspan="1">舒适范围</td>
                                    <td colspan="1">高临界</td>
                                    <td colspan="1">低临界</td>
                                    <td colspan="1">舒适范围</td>
                                    <td colspan="1">高临界</td>
                                    <td colspan="1">低临界</td>
                                </tr>
                                <tr>
                                    <td colspan="1">种公猪舍</td>
                                    <td colspan="1">15~20</td>
                                    <td colspan="1">25</td>
                                    <td colspan="1">13</td>
                                    <td colspan="1">60~70</td>
                                    <td colspan="1">85</td>
                                    <td colspan="1">50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">空怀妊娠母猪舍</td>
                                    <td colspan="1">15~20</td>
                                    <td colspan="1">27</td>
                                    <td colspan="1">13</td>
                                    <td colspan="1">60~70</td>
                                    <td colspan="1">85</td>
                                    <td colspan="1">50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">哺乳母猪舍</td>
                                    <td colspan="1">18~22</td>
                                    <td colspan="1">27</td>
                                    <td colspan="1">16</td>
                                    <td colspan="1">60~70</td>
                                    <td colspan="1">80</td>
                                    <td colspan="1">50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">哺乳仔猪保温箱</td>
                                    <td colspan="1">28~32</td>
                                    <td colspan="1">35</td>
                                    <td colspan="1">27</td>
                                    <td colspan="1">60~70</td>
                                    <td colspan="1">80</td>
                                    <td colspan="1">50</td>
                                </tr>
                               
                                <tr>
                                    <td colspan="1">保育猪舍</td>
                                    <td colspan="1">20~25</td>
                                    <td colspan="1">28</td>
                                    <td colspan="1">16</td>
                                    <td colspan="1">60~70</td>
                                    <td colspan="1">80</td>
                                    <td colspan="1">50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">生长育肥猪舍</td>
                                    <td colspan="1">15~23</td>
                                    <td colspan="1">27</td>
                                    <td colspan="1">13</td>
                                    <td colspan="1">65~75</td>
                                    <td colspan="1">85</td>
                                    <td colspan="1">50</td>
                                </tr>
                                <tr>
                                    <td colspan="7">
                                        <van-col span="24">
                                        注1、表中哺乳仔猪保温箱的温度是仔猪1周龄以内的临界范围。2~4周龄时的下限温度可降至26~24℃。表中其他数值均指猪床上0.7m处的温度和湿度。
                                        </van-col>
                                        <van-col span="24">
                                        注2、表中的高、低临界值指生产临界范围，过高或过低都会影响猪的生产性能和健康状况。生长育肥猪舍的温度，在月份平均气温高于28℃时，允许将上限提高1-3℃，月份平均气温低于-5℃时，允许将下限降低1~5℃。
                                        </van-col>
                                        <van-col span="24">
                                        注3、在密闭式有采暖设备的猪舍，其适宜的相对湿度比上述数值要低5~8%。
                                        </van-col>
                                    </td>
                                </tr>
                            </table>
                            <van-row>
                                <van-col span="24">
                                    哺乳母猪和哺乳仔猪需要的温度不同，应对哺乳仔猪采取保温箱单独供暖。
                                </van-col>
                                <van-col span="24">
                                    猪舍环境温度高于临界范围上限时，应采取喷雾、湿帘和遮阳等降温措施，加强通风，保证清洁饮水，提高日粮营养水平。
                                </van-col>
                                <van-col span="24">
                                    猪舍环境温度低于临界范围下限值时，应采取供暖、保温措施，保持圈舍干燥，控制风速，防止贼风，提高日粮营养水平。
                                </van-col>
                            </van-row>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="3、猪舍空气卫生指标" name="3">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                                猪舍空气中的氨（NH<sub style=" vertical-align: sub;">3</sub>）、硫化氢（H<sub style=" vertical-align: sub;">2</sub>S）、二氧化碳（CO<sub style=" vertical-align: sub;">3</sub>）、细菌总数和粉尘不宜超过下表中的数值。
                            </van-col>
                            <table class="health_tab">
                                <tr>
                                    <th>猪舍类别</th>
                                    <th>氨</th>
                                    <th>硫化氢</th>
                                    <th>二氧化</th>
                                    <th>细菌总数</th>
                                    <th>粉尘</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>/( mg/m³)</td>
                                    <td>/( mg/m³)</td>
                                    <td>碳/( mg/m³)</td>
                                    <td>/(万个/ m³)</td>
                                    <td>/( mg/m³)</td>
                                </tr>
                                <tr>
                                    <td>种公猪舍</td>
                                    <td>25</td>
                                    <td>10</td>
                                    <td>1500</td>
                                    <td>6</td>
                                    <td>1.5</td>
                                </tr>
                                <tr>
                                    <td>空怀妊娠母猪舍</td>
                                    <td>25</td>
                                    <td>10</td>
                                    <td>1500</td>
                                    <td>6</td>
                                    <td>1.5</td>
                                </tr>
                                <tr>
                                    <td>哺乳母猪舍</td>
                                    <td>20</td>
                                    <td>8</td>
                                    <td>1300</td>
                                    <td>4</td>
                                    <td>1.2</td>
                                </tr>
                                <tr>
                                    <td>保育猪舍</td>
                                    <td>20</td>
                                    <td>8</td>
                                    <td>1300</td>
                                    <td>4</td>
                                    <td>1.2</td>
                                </tr>
                                <tr>
                                    <td>生长育肥猪舍</td>
                                    <td>25</td>
                                    <td>10</td>
                                    <td>1500</td>
                                    <td>6</td>
                                    <td>1.5</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                 <van-collapse-item title="4、猪舍通风量和风速指标" name="4">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1" rowspan="2">猪舍类别</th>
                                    <th colspan="3">通风量/[m³/(h▪kg)]</th>
                                    <th colspan="2">风速</th>
                                </tr>
                                <tr>
                                    <td colspan="1">冬季</td>
                                    <td colspan="1">春秋季</td>
                                    <td colspan="1">夏季</td>
                                    <td colspan="1">冬季</td>
                                    <td colspan="1">夏季</td>
                                </tr>
                                <tr>
                                    <td colspan="1">种公猪舍</td>
                                    <td colspan="1">0.35</td>
                                    <td colspan="1">0.55</td>
                                    <td colspan="1">0.70</td>
                                    <td colspan="1">0.30</td>
                                    <td colspan="1">1.00</td>
                                </tr>
                                <tr>
                                    <td colspan="1">空怀、妊娠母猪舍</td>
                                    <td colspan="1">0.30</td>
                                    <td colspan="1">0.45</td>
                                    <td colspan="1">0.60</td>
                                    <td colspan="1">0.30</td>
                                    <td colspan="1">1.00</td>
                                </tr>
                                <tr>
                                    <td colspan="1">哺乳母猪舍</td>
                                    <td colspan="1">0.30</td>
                                    <td colspan="1">0.45</td>
                                    <td colspan="1">0.60</td>
                                    <td colspan="1">0.15</td>
                                    <td colspan="1">0.40</td>
                                </tr>
                                <tr>
                                    <td colspan="1">保育猪舍</td>
                                    <td colspan="1">0.30</td>
                                    <td colspan="1">0.45</td>
                                    <td colspan="1">0.60</td>
                                    <td colspan="1">0.20</td>
                                    <td colspan="1">0.60</td>
                                </tr>
                                <tr>
                                    <td colspan="1">生长育肥猪舍</td>
                                    <td colspan="1">0.35</td>
                                    <td colspan="1">0.50</td>
                                    <td colspan="1">0.65</td>
                                    <td colspan="1">0.30</td>
                                    <td colspan="1">1.00</td>
                                </tr>
                                <tr>
                                    <td colspan="6">
                                         <van-col span="24">
                                            注1、通风量是指每千克活猪每小时需要的空气量。
                                        </van-col>
                                        <van-col span="24">
                                            注2、风速是指猪只所在位置的夏季适宜值和冬季最大值。
                                        </van-col>
                                        <van-col span="24">
                                            注3、在月份平均温度≥28℃的炎热季节，应采取降温措施。
                                        </van-col>
                                    </td>
                                </tr>
                            </table>
                            <van-col span="24">
                                1）猪舍人工照明易使用节能灯，光照应均匀，按照灯距3m、高度2.1~2.4m、每灯光照面积9~12m²的原则布置。
                            </van-col>
                            <van-col span="24">
                                2）猪舍的灯具和门窗等透光构件应保持清洁。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="5、猪舍采光指标" name="5">
                    <van-row>
                        <van-col span="24">
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1" rowspan="2">猪舍类别</th>
                                    <th colspan="2">自然光照</th>
                                    <th colspan="2">人工光照</th>
                                </tr>
                                <tr>
                                    <td colspan="1">窗地比</td>
                                    <td colspan="1">辅助照明/1x</td>
                                    <td colspan="1">光照度/1x</td>
                                    <td colspan="1">光照时间/h</td>
                                </tr>
                                <tr>
                                    <td colspan="1">种公猪舍</td>
                                    <td colspan="1">1:12~1:10</td>
                                    <td colspan="1">50~75</td>
                                    <td colspan="1">350~400</td>
                                    <td colspan="1">14~16</td>
                                </tr>
                                <tr>
                                    <td colspan="1">空怀、妊娠母猪舍</td>
                                    <td colspan="1">1:15~1:12</td>
                                    <td colspan="1">50~75</td>
                                    <td colspan="1">350~400</td>
                                    <td colspan="1">14~16</td>
                                </tr>
                                <tr>
                                    <td colspan="1">哺乳母猪舍</td>
                                    <td colspan="1">1:12~1:10</td>
                                    <td colspan="1">50~75</td>
                                    <td colspan="1">350~400</td>
                                    <td colspan="1">14~16</td>
                                </tr>
                                <tr>
                                    <td colspan="1">保育猪舍</td>
                                    <td colspan="1">1:10</td>
                                    <td colspan="1">50~75</td>
                                    <td colspan="1">350~400</td>
                                    <td colspan="1">14~16</td>
                                </tr>
                                <tr>
                                    <td colspan="1">生长育肥猪舍</td>
                                    <td colspan="1">1:15~1:12</td>
                                    <td colspan="1">50~75</td>
                                    <td colspan="1">300~350</td>
                                    <td colspan="1">12~16</td>
                                </tr>
                                <tr>
                                    <td colspan="5">
                                         <van-col span="24">
                                            注1、窗地比是以猪舍门窗等透光面积为1，与舍内地面积之比。
                                        </van-col>
                                        <van-col span="24">
                                            注2、辅助照明是指自然光照猪舍设置人工照明以备夜晚工作照明用。
                                        </van-col>
                                    </td>
                                </tr>
                            </table>
                            <van-col span="24">
                                1）猪舍人工照明易使用节能灯，光照应均匀，按照灯距3m、高度2.1~2.4m、每灯光照面积9~12m²的原则布置。
                            </van-col>
                            <van-col span="24">
                                2）猪舍的灯具和门窗等透光构件应保持清洁。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                 <van-collapse-item title="6、猪舍噪声指标" name="6">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                                各类猪舍的生产噪声和外界传入噪声不得超过80dB，应避免突发的强烈噪音。
                            </van-col>
                            <van-col span="24">
                                加强猪舍周围绿化，降低外部噪声的传入。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                 <van-collapse-item title="7、饲养空间指标" name="7">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                               1）对仔猪、育成猪和育肥猪所需最小饲养空间应符合以下要求（单位是m²/头）：
                            </van-col>
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1">猪类别（体重kg）</th>
                                    <th colspan="1">m<sup class="up_hea">2</sup>/头</th>
                                </tr>
                                <tr>
                                    <td colspan="1"> <10 </td>
                                    <td colspan="1">0.15</td>
                                </tr>
                                <tr>
                                    <td colspan="1">10~20</td>
                                    <td colspan="1">0.20</td>
                                </tr>
                                <tr>
                                    <td colspan="1">20~30</td>
                                    <td colspan="1">0.30</td>
                                </tr>
                                <tr>
                                    <td colspan="1">30~50</td>
                                    <td colspan="1">0.40</td>
                                </tr>
                                <tr>
                                    <td colspan="1">50~85</td>
                                    <td colspan="1">0.55</td>
                                </tr>
                                <tr>
                                    <td colspan="1">85~110</td>
                                    <td colspan="1">0.65</td>
                                </tr>
                                <tr>
                                    <td colspan="1">>110</td>
                                    <td colspan="1">1.00</td>
                                </tr>
                            </table>
                            <van-col span="24">
                              2）不同体重猪个体的理论饲养空间需求
                            </van-col>
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1" style="width:30px;" rowspan="3">猪群类别</th>
                                    <th colspan="1" rowspan="3">体重kg</th>
                                    <th colspan="5">基本生活空间m²/头</th>
                                    <th colspan="1">活动空间m²/头</th>
                                    <th colspan="1" rowspan="3">合计m²/头</th>
                                </tr>
                                <tr>
                                    <td colspan="2"> 躺卧 </td>
                                    <td colspan="1" rowspan="2">采食</td>
                                    <td colspan="1" rowspan="2">饮水</td>
                                    <td colspan="1" rowspan="2">排泄</td>
                                    <td colspan="1" rowspan="2">站立/行走/活动排泄</td>
                                </tr>
                                <tr>
                                    <td colspan="1">俯卧</td>
                                    <td colspan="1">侧卧</td>
                                </tr>
                                <tr>
                                    <td colspan="1">初生仔猪</td>
                                    <td colspan="1">2</td>
                                    <td colspan="1">0.03</td>
                                    <td colspan="1">0.08</td>
                                    <td colspan="1">0.03</td>
                                    <td colspan="1">0.03</td>
                                    <td colspan="1">0.03</td>
                                    <td colspan="1">0.03</td>
                                    <td colspan="1">0.15~0.20</td>
                                </tr>
                                <tr>
                                    <td colspan="1">28日龄仔猪</td>
                                    <td colspan="1">8</td>
                                    <td colspan="1">0.08</td>
                                    <td colspan="1">0.20</td>
                                    <td colspan="1">0.08</td>
                                    <td colspan="1">0.08</td>
                                    <td colspan="1">0.08</td>
                                    <td colspan="1">0.08</td>
                                    <td colspan="1">0.40~0.52</td>
                                </tr>
                                <tr>
                                    <td colspan="1">70日龄仔猪</td>
                                    <td colspan="1">25</td>
                                    <td colspan="1">0.17</td>
                                    <td colspan="1">0.43</td>
                                    <td colspan="1">0.17</td>
                                    <td colspan="1">0.17</td>
                                    <td colspan="1">0.17</td>
                                    <td colspan="1">0.17</td>
                                    <td colspan="1">0.85~1.11</td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="3">生长育肥猪</td>
                                    <td colspan="1">60</td>
                                    <td colspan="1">0.31</td>
                                    <td colspan="1">0.76</td>
                                    <td colspan="1">0.31</td>
                                    <td colspan="1">0.31</td>
                                    <td colspan="1">0.31</td>
                                    <td colspan="1">0.31</td>
                                    <td colspan="1">1.55~2.00</td>
                                </tr>
                                <tr>
                                    <td colspan="1">90</td>
                                    <td colspan="1">0.40</td>
                                    <td colspan="1">1.14</td>
                                    <td colspan="1">0.40</td>
                                    <td colspan="1">0.40</td>
                                    <td colspan="1">0.40</td>
                                    <td colspan="1">0.40</td>
                                    <td colspan="1">2.00~2.60</td>
                                </tr>
                                <tr>
                                    <td colspan="1">110</td>
                                    <td colspan="1">0.46</td>
                                    <td colspan="1">1.14</td>
                                    <td colspan="1">0.46</td>
                                    <td colspan="1">0.46</td>
                                    <td colspan="1">0.46</td>
                                    <td colspan="1">0.46</td>
                                    <td colspan="1">2.30~2.98</td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="2">母猪</td>
                                    <td colspan="1">150</td>
                                    <td colspan="1">1.14</td>
                                    <td colspan="1">0.76</td>
                                    <td colspan="1">0.56</td>
                                    <td colspan="1">0.56</td>
                                    <td colspan="1">0.56</td>
                                    <td colspan="1">0.56</td>
                                    <td colspan="1">2.80~3.65</td>
                                </tr>
                                <tr>
                                    <td colspan="1">200</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">1.70</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">3.40~4.42</td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="2">公猪</td>
                                    <td colspan="1">200</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">1.70</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">0.68</td>
                                    <td colspan="1">3.40~4.42</td>
                                </tr>
                                <tr>
                                    <td colspan="1">250</td>
                                    <td colspan="1">0.79</td>
                                    <td colspan="1">1.98</td>
                                    <td colspan="1">0.79</td>
                                    <td colspan="1">0.79</td>
                                    <td colspan="1">0.79</td>
                                    <td colspan="1">0.79</td>
                                    <td colspan="1">3.95~5.14</td>
                                </tr>
                            </table>
                            <van-col span="24">
                                种公猪饲养面积不低于9.0m²/头，后备、空怀、妊娠母猪不低于2.4 m²/头，哺乳母猪不低于4.8 m²/头，保育猪不低于0.5 m²/头，生长猪不低于1.0 m²/头，育肥猪不低于1.6 m²/头。
                            </van-col>
                            <van-col span="24">
                                3）任何情况下猪都可以自由转身（产仔的母猪除外），猪有干燥的躺卧区，可以同时躺卧。
                            </van-col>
                            <van-col span="24">
                                4）躺卧面积应符合第1）条，配种后的后背母猪和妊娠母猪躺卧区应是无缝坚固的地板，面积至少分别为0.95m²/头和1.3m²/头，其中有不超过15%的面积用作排污区。
                            </van-col>
                            <van-col span="24">
                               5）围栏的长宽比以1.5~2:1为宜。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                 <van-collapse-item title="8、母猪设施指标" name="8">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                                1）母猪舍设施，除产前7d到产后28d（断奶时除外），应允许其自由活动，产前7d到产后28天期间可使用隔栏，断奶不能栓系。确保母猪不被单独隔离。
                            </van-col>
                            <van-col span="24">
                                2）产床中不应栓系母猪。
                            </van-col>
                            <van-col span="24">
                                3）母猪产仔前在产床中不应超过7d；产仔后在产床中不宜超过42d。
                            </van-col>
                            <van-col span="24">
                                4）产床应足够长，使母猪可以舒适躺卧。长度应可以调整，以防止母猪过多的自由活动。但应无母猪和产床摩擦而造成臀部和背部受伤的迹象。
                            </van-col>
                            <van-col span="24">
                                5）产床顶部的横梁和床底应有足够的距离，以确保母猪正常活动。
                            </van-col>
                            <van-col span="24">
                                6）群饲养后备母猪和（或）妊娠母猪时，其饲养空间应保持在1.64m²/头和2.25m²/头以上。当猪群内猪的数量少于6头，则整体饲养空间可以增加但不超过总面积的10%；当猪群内猪的数量多于40头，则整体饲养空间可减少但不能超过总面积的10%。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="9、猪的来源" name="9">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                               1）所有引入猪应带有免疫耳标，并有畜牧兽医部门出具的检疫证、非疫区证明和车辆消毒证明。
                            </van-col>
                            <van-col span="24">
                                2）引进种猪时，应隔离观察15~30d，经兽医检查确定为健康合格后，方可供繁殖使用。
                            </van-col>
                            <van-col span="24">
                                3）猪场中所有的猪都应具有可追溯性，不得来自于生猪交易市场，运输过程中应远离生猪交易市场。
                            </van-col>
                            <van-col span="24">
                                4）猪场应保证猪的来源、品种、来源途径以及人工授精精液来源的书面记录。
                            </van-col>
                            <van-col span="24">
                                5）繁殖用种猪的氟烷基因检测应为显性纯合子（NN），品种纯正。相关记录和声明应保存3年。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="10、猪的标识" name="10">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                               1）送宰前应检查每一头猪，保证其有永久的身份标识。
                            </van-col>
                            <van-col span="24">
                               2）猪的标识设备应由接受过良好培训、具备相应能力的员工使用，并对设备进行维护。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="11、饲料和饮用水指标" name="11">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                               1）圈养猪应有足够长的料槽，确保每头猪都能同时进食。饲喂量适宜，少喂勤添，防止饲料污染腐败。
                            </van-col>
                            <van-col span="24">
                               2）应知饲料原料组分并可追溯其来源，保存好饲料验收记录。
                            </van-col>
                            <van-col span="24">
                               3）应记录自配饲料的配方并保存3年。
                            </van-col>
                            <van-col span="24">
                               4）自配饲料的成分含量记录和样品应至少保存6个月。
                            </van-col>
                            <van-col span="24">
                               5）禁止使用餐饮业的废弃物喂猪。
                            </van-col>
                            <van-col span="24">
                               6）每天应向猪供应充足、清洁的饮用水。
                            </van-col>
                             <van-col span="24">
                               7）应有水质检测的证据。
                            </van-col>
                            <van-col span="24">
                               8）饮水设置应按以下要求进行：
                            </van-col>
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1">猪群类别</th>
                                    <th colspan="1">饲养头数</th>
                                    <th colspan="1">配置的设备</th>
                                    <th colspan="1">躺卧区域配置</th>
                                </tr>
                                <tr>
                                    <td colspan="1">种公猪</td>
                                    <td colspan="1">1</td>
                                    <td colspan="1">1个饮水器，一个饲槽</td>
                                    <td colspan="1"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="2">母猪（含后备、空怀、妊娠母猪）</td>
                                    <td colspan="1">4~6</td>
                                    <td colspan="1">2个饮水器，4~6个饲槽位</td>
                                    <td colspan="1" rowspan="2">不少于1.40m²/头的躺卧面积</td>
                                </tr>
                                <tr>
                                    <td colspan="1">8~12</td>
                                    <td colspan="1">3个饮水器，8~12个饲槽位</td>
                                </tr>
                                <tr>
                                    <td colspan="1">哺乳母猪（含哺乳仔猪）</td>
                                    <td colspan="1">1（10）</td>
                                    <td colspan="1">母猪、仔猪饮水器各1个，1个饲槽，1个仔猪补饲槽</td>
                                    <td colspan="1">1个仔猪暖床或保温箱</td>
                                </tr>
                                <tr>
                                    <td colspan="1">保育猪</td>
                                    <td colspan="1">40~80</td>
                                    <td colspan="1">4~8个饮水器，4~8个饲槽位，2套玩具和蹭痒架</td>
                                    <td colspan="1">4~8和暖床，或不少于0.15m²/头的躺卧面积</td>
                                </tr>
                                <tr>
                                    <td colspan="1">生长猪</td>
                                    <td colspan="1">20~40</td>
                                    <td colspan="1">3~4个饮水器，4~6个饲槽位，4个蹭痒架</td>
                                    <td colspan="1">不少于0.35m²/头的躺卧面积</td>
                                </tr>
                                <tr>
                                    <td colspan="1">育肥猪</td>
                                    <td colspan="1">20~40</td>
                                    <td colspan="1">3~4个饮水器，6~8个饲槽位，4个蹭痒架</td>
                                    <td colspan="1">不少于0.50m²/头的躺卧面积</td>
                                </tr>
                            </table>
                            <van-col span="24">
                               9）饮水量与饮水设施指标
                            </van-col>
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1" style="padding:0;">
                                        <div class="out" style="font-size:27px">  
                                            <b>项</b><i class="icoa">日</i> <em>阶段</em>  
                                        </div>  
                                    </th>
                                    <th colspan="1">饮水器流水量至少<p style="word-break:break-all;">（mL/min）</p></th>
                                    <th colspan="1">猪每天采食1kg干饲料至少需要饮水（L）</th>
                                    <th colspan="1">日消耗水量（L）</th>
                                    <th colspan="1">饮水器安装高度以猪的肩关节水平高出（cm）</th>
                                    <th colspan="1">饮水器安装间距（cm）</th>
                                    <th colspan="1">饮水器的选择</th>
                                    <th colspan="1">每栋猪舍主供水管口径（mm）</th>
                                </tr>
                                <tr>
                                    <td colspan="1">哺乳仔猪</td>
                                    <td colspan="1"></td>
                                    <td colspan="1"></td>
                                    <td colspan="1"></td>
                                    <td colspan="1"></td>
                                    <td colspan="1"></td>
                                    <td colspan="1">无压杯式</td>
                                    <td colspan="1"></td>
                                </tr>
                                <tr>
                                    <td colspan="1">断奶仔猪（5-10kg）</td>
                                    <td colspan="1"></td>
                                    <td colspan="1">2</td>
                                    <td colspan="1">1.5-2.5</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">45</td>
                                    <td colspan="1">乳头式</td>
                                    <td colspan="1">45-50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">小猪(10-35 kg) </td>
                                    <td colspan="1">200-500</td>
                                    <td colspan="1">2-2.5</td>
                                    <td colspan="1">2.5-4.0</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">45</td>
                                    <td colspan="1">乳头式</td>
                                    <td colspan="1">45-50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">中猪   （35-75 kg） </td>
                                    <td colspan="1">500-750</td>
                                    <td colspan="1">2.5-3</td>
                                    <td colspan="1">4.0-6.0</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">45</td>
                                    <td colspan="1">乳头式</td>
                                    <td colspan="1">45-50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">大猪  （75-100 kg） </td>
                                    <td colspan="1">750-1100</td>
                                    <td colspan="1">2.5-3</td>
                                    <td colspan="1">6.0-10.0</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">45</td>
                                    <td colspan="1">乳头式</td>
                                    <td colspan="1">45-50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">断奶母猪后备母猪及公猪 </td>
                                    <td colspan="1">2000</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">15-20</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">1个/头</td>
                                    <td colspan="1"></td>
                                    <td colspan="1">45-50</td>
                                </tr>
                                <tr>
                                    <td colspan="1">哺乳母猪 </td>
                                    <td colspan="1">2500</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">20-25</td>
                                    <td colspan="1">5</td>
                                    <td colspan="1">1个/头</td>
                                    <td colspan="1">乳头式</td>
                                    <td colspan="1">45-50</td>
                                </tr>
                                <tr>
                                    <td colspan="8">
                                        <van-col span="24">
                                            备注：乳猪的饮水要注意：仔猪出生后三天就会有饮水的行为，这时应要满足乳猪的饮水，补饲时一定要供给充足的清洁饮水，否则补饲常常失败
                                        </van-col>
                                    </td>
                                    
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="12、室外养猪" name="12">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                              1）室外养猪的场所应设在易于排水和不会受洪水影响的地方。以沙土、砂砾和石灰渣为主的土壤较好，不应选择黏土和泥沙性土壤。
                            </van-col>
                            <van-col span="24">
                               2）产仔的棚屋应建在地势平坦、避免有陡坡的地方。应为猪提供适当的圈舍。
                            </van-col>
                            <van-col span="24">
                              3）应提供适宜的垫草，保证温暖舒适。
                            </van-col>
                            <van-col span="24">
                               4）每公顷土地上放养母猪的数量不应超过30头。
                            </van-col>
                            <van-col span="24">
                              5）在养猪和饲料存放场所额周围，应对害虫和其他动物进行控制。
                            </van-col>
                            <van-col span="24">
                               6）应配备训导区域使新转群的母猪、公猪适应带电围栏。
                            </van-col>
                            <van-col span="24">
                              7）在炎热季节应提供保持凉爽的设施。
                            </van-col>
                            <van-col span="24">
                               8）母猪产仔时应在温度适宜，无风的棚屋内进行。
                            </van-col>
                            <van-col span="24">
                              9）产仔的棚屋应有干燥清洁的垫草。
                            </van-col>
                            <van-col span="24">
                              10）当土壤类型、设施和石子可能会对猪造成伤害时，采使用鼻环。
                            </van-col>
                            <van-col span="24">
                              11）产仔的棚屋和断奶仔猪的活动场所应在每个使用周期后进行清洁消毒，用过的垫草应更换和焚烧。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="13、机械设备" name="13">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                              1）所有设备（包括食槽、饮水器、排风扇、加热器、光照设备、灭火器和报警系统）应保持清洁，并进行维护确保正常工作。
                            </van-col>
                            <van-col span="24">
                               2）应每日检查自动化设备如自动喂料系统和通风系统，确保正常工作。
                            </van-col>
                            <van-col span="24">
                              3）猪舍内，自然通风如不能满足要求，则应能提供自动通风系统。
                            </van-col>
                            <van-col span="24">
                               4）每周检查一次报警系统。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="14、治疗圈" name="14">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                              1）应有指定的治疗圈以隔离和治疗伤病猪。
                            </van-col>
                            <van-col span="24">
                               2）应对治疗圈中的猪每天至少进行两次检查。对治疗无效的猪应立即征求兽医的处理意见或实施人道屠宰。
                            </van-col>
                            <van-col span="24">
                              3）治疗圈应通风良好、结构合理、温暖干燥并为伤病猪提供适宜的躺卧区。
                            </van-col>
                            <van-col span="24">
                               4）治疗圈在重新使用前，应腾空并彻底清扫消毒。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="15、节能减排及处理技术指标" name="15">
                    <van-row>
                        <van-col span="24">
                            <van-col span="24">
                              宜采用节水型饮水设备；躺卧区宜采用局部加温或降温措施；应减少圈栏冲洗用水。
                            </van-col>
                            <van-col span="24">
                               宜采用低蛋白平衡日粮等动物营养调控技术，降低粪便中有机物的排放。
                            </van-col>
                            <van-col span="24">
                              粪污治理工程的设计、施工、验收和运行维护应符合HJ497-2009的技术要求；粪污处理和利用应符合《畜禽规模养殖污染防治条例》及GB18596的规定。
                            </van-col>
                            <van-col span="24">
                               宜采用物理、化学、生物等方法减少臭气排放，排放浓度应符合GB18596的规定。
                            </van-col>
                            <van-col span="24">
                               病死猪及污物处理用按照GB16548的规定执行。
                            </van-col>
                            <van-col span="24">
                               猪场环境质量要求可按照GB/T17824.3执行。
                            </van-col>
                        </van-col>
                    </van-row>
                </van-collapse-item>
            </van-collapse>
            
        </van-row>
        
      
    </div>
     <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
import { labbiosafetyeval } from '@/api/resetApi.js'

export default {
  name: 'health_ambient',
  components: {
    Top
  },
  data(){
    return{
        activeNames: ['1'],
        grade_num: '',
        btnFlag:false,
        eval_result: '',
        browser: {
            trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
            presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
            webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
            mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
            ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
            webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
        },
        goodsList: [],
      isWx:1,
    };
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    async labbiosafetyeval() {
      let qs = require('qs');
      let data = qs.stringify(JSON.parse(this.laboratorylist))
      const res = await labbiosafetyeval(data)
      console.log(res)
      try {
        if (res.data.code === 1) {
          this.grade_num = res.data.grade_num
          if (res.grade_num>=76) {
            this.eval_result = res.data.eval_result+',继续保持哦～'
          } else{
            this.eval_result = res.data.eval_result+',待整改完善'
          }
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    retest() {
      this.$store.state.report.laboratorydata = []
      this.$router.back(-1)
    },
    laboratorys() {
      if (this.browser.android) {
        ZKAPP.laboratory();
      }else {
        window.webkit.messageHandlers.laboratory.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<style lang="scss">
.health_ambient{
    .up_hea{
        vertical-align:super;
    }
    .van-cell__title{
        text-align: left;
        span{
            // font-weight: bold;
            font-size: 16px;
        }
    }
    .health_tab{
        width:100%;
        table-layout: fixed;
        border-collapse:collapse;
        tr td{
            border:1px  solid #CCCCCC;
            padding: .05rem;
            word-wrap : break-word;
            vertical-align: middle;
            text-align: center;
        }
        th{
            border:1px  solid #CCCCCC;
            padding: .05rem;
            font-size: 14px;
            vertical-align: middle;
            text-align: center;
        }
    }
    .out{ 
        border-top:211px #f5f5f5 solid;/*上边框宽度等于表格第一行行高*/ 
        width:0px;/*让容器宽度为0*/ 
        height:0px;/*让容器高度为0*/ 
        border-left:47px #ddd solid;/*左边框宽度等于表格第一行第一格宽度*/ 
        position:relative;/*让里面的两个子容器绝对定位*/ 
        } 
        b{font-style:normal;display:block;position:absolute;top:-199px;left:-34px;width:35px;font-size: 14px;} 
        em{font-style:normal;display:block;position:absolute;top:-25px;left:-43px;width:55px;font-size: 14px;} 
        .icoa{font-style:normal;display:block;position:absolute;top:-109px;left:-43px;width:55px;font-size: 14px;}
     .van-col {
      
        
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        background-clip: content-box;
        color: #4C4C4C;
        border: 1px solid #F5F5F5;
       
       
        margin: 5px;
    }
    .van-collapse-item__content{
        background:#F5F5F5 ;
    }
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .swine_wrap{
        font-size: 14px;
    }
    .health_ambient_title{
        padding: .2rem;
        background: #F6F9FF;
        text-align: left;
        font-weight: bold;
        font-size: 16px;
    }
    .health_ambient_card{
        padding: .2rem;
        .van-col {
            margin-bottom: 10px;
            
            font-size: 14px;
            line-height: 50px;
            text-align: left;
            background-clip: content-box;
            color: #4C4C4C;
            border: 1px solid #F5F5F5;
            padding: 0!important;
            width: 30%;
            margin: 5px;
        }
    }
    .health_ambient_icon{
        // padding: .2rem;
            // background-color: #66c6f2;
        // border: 1px solid #F5F5F5;
    }
    
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
.res2{
  width: 200px;
  height: 200px;
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
  color:#fff;
}
.res{
  width: 200px;
  height: 200px;
  background: url(../../assets/subjectimg/t1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
  color:#fff;

}
.res1{
  width: 200px;
  height: 200px;
  background: url(../../assets/subjectimg/b1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
}
.branch{
  font-size: 70px;
}
.branch1{
  font-size: 24px;
}
img{
  display: inline-block;
  vertical-align: middle;
}
.res_text{
  padding: 60px 0;
  font-size: 0;
  text-align: center;
}
.res_text span{
  margin-left: 10px;
  vertical-align: middle;
  font-size: 20px;
  color: #4A4A4A;
}
.res_text img{
  width: 30px;
  height: 30px;
}
.btn_bottom {
  font-size: 0;
}
</style>
